import React from "react";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import { CgWebsite } from "react-icons/cg";
import { BsGithub } from "react-icons/bs";

function ProjectCards(props) {
  return (
    <div className="flip-card">
      <div className="flip-card-inner">
        {/* Front Side */}
        <div className="flip-card-front">
          <img src={props.imgPath} alt="card-img" />
          <h4 style={{ padding: "10px" }}>{props.title}</h4>
        </div>

        {/* Back Side */}
        <div className="flip-card-back">
          <h5><b>{props.title}</b></h5>
          <p style={{ textAlign: "justify" }}>{props.description}</p>
          <ul>
            <li>{props.technologies}</li>
          </ul>

          <div style={{ marginTop: "10px" }}>
            <Button variant="primary" href={props.ghLink} target="_blank">
              <BsGithub /> &nbsp;
              {props.isBlog ? "Blog" : "GitHub"}
            </Button>

            {!props.isBlog && props.demoLink && (
              <Button
                variant="primary"
                href={props.demoLink}
                target="_blank"
                style={{ marginLeft: "10px" }}
              >
                <CgWebsite /> &nbsp;
                {"Demo"}
              </Button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default ProjectCards;
